import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-business-credit-info',
  templateUrl: './business-credit-info.component.html'

})
export class BusinessCreditInfoComponent implements OnInit {
  @Input() myform!: FormGroup;
  constructor() { }

  ngOnInit() {
  }

  ReturnFormControl(pControl:string)
  {
    return (<FormControl>(this.myform).controls[pControl]);
  }
  
  ReturnMyFormWithControl(pControl:string)
  {
    return <FormGroup>this.myform.controls[pControl];
  }
  
}
